import React, { useEffect, useState } from "react";
import { personLabel } from "../../lib/teamManagement";

/**
 * Смяна на мениджър.
 *
 * Only Мениджъри who are free — active, and not already managing another active
 * team — are offered; the server re-checks all of it. Changing the Manager moves
 * NOTHING else: the Търговци stay in the team, organization roles stay as they
 * are, offers keep their owners, and no licensed seat is consumed or freed.
 */
export const TeamManagerDialog = ({
  open,
  team,
  managers,
  submitting,
  error,
  onCancel,
  onSubmit,
}) => {
  const [managerId, setManagerId] = useState("");

  useEffect(() => {
    if (open) setManagerId("");
  }, [open, team?.id]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape" && !submitting) onCancel();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, submitting, onCancel]);

  if (!open || !team) return null;

  const options = (managers || []).filter((m) => m.member_id !== team.manager?.member_id);

  return (
    <div className="qw-modal-backdrop">
      <div
        className="qw-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="team-manager-title"
        data-testid="team-manager-dialog"
      >
        <div className="h" id="team-manager-title">
          Смяна на мениджър
        </div>
        <div className="body">
          <p style={{ margin: 0, fontSize: 13, color: "#475569" }} data-testid="team-manager-current">
            {team.name} — сега: {personLabel(team.manager) || "—"}
          </p>

          <div className="qw-field" style={{ marginTop: 12 }}>
            <label htmlFor="team-manager-select">Нов мениджър</label>
            <select
              id="team-manager-select"
              className="qw-select"
              value={managerId}
              onChange={(e) => setManagerId(e.target.value)}
              disabled={submitting}
              data-testid="team-manager-select"
            >
              <option value="">Изберете мениджър</option>
              {options.map((m) => (
                <option
                  key={m.member_id}
                  value={m.member_id}
                  data-testid={`team-manager-option-${m.member_id}`}
                >
                  {personLabel(m)}
                </option>
              ))}
            </select>
            {options.length === 0 && (
              <div className="qw-help" data-testid="team-manager-empty">
                Няма свободен мениджър. Всеки активен мениджър вече управлява екип.
              </div>
            )}
          </div>

          <div className="qw-help" data-testid="team-manager-note">
            Търговците в екипа остават същите. Офертите не се преразпределят.
          </div>

          {error && (
            <div className="qw-error" role="alert" style={{ marginTop: 10 }} data-testid="team-manager-error">
              {error}
            </div>
          )}
        </div>
        <div className="footer">
          <button
            type="button"
            className="qw-btn ghost"
            onClick={onCancel}
            disabled={submitting}
            data-testid="team-manager-cancel"
          >
            Отказ
          </button>
          <button
            type="button"
            className="qw-btn primary"
            onClick={() => onSubmit({ manager_member_id: managerId })}
            disabled={submitting || !managerId}
            data-testid="team-manager-submit"
          >
            {submitting ? "Записване…" : "Смени мениджъра"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeamManagerDialog;
